import { darken, getContrastRatio, lighten } from '@mui/material/styles'

// Cor de destaque usada como TEXTO precisa ser lida em qualquer tema. O ciano
// da marca (#00ccff) é ótimo como preenchimento, mas como texto sobre branco
// fica em 1,9:1 — some. Aqui a cor é escurecida (fundo claro) ou clareada (fundo
// escuro) só o suficiente pra passar do mínimo de leitura; se já passa, volta
// intacta. Serve aos quatro temas do painel sem tabela de cor por tema.
//
// 4,5:1 é o mínimo pra texto corrido (WCAG AA). Números grandes e negritos
// passariam com 3:1, mas o mesmo helper atende rótulos pequenos — fica o mais
// exigente.
export function corLegivel(cor, fundo, minimo = 4.5) {
  if (!cor || !fundo) return cor
  try {
    if (getContrastRatio(cor, fundo) >= minimo) return cor
    const fundoEscuro = getContrastRatio(fundo, '#000') < getContrastRatio(fundo, '#fff')
    let atual = cor
    for (let passo = 1; passo <= 9; passo++) {
      atual = fundoEscuro ? lighten(cor, passo * 0.1) : darken(cor, passo * 0.1)
      if (getContrastRatio(atual, fundo) >= minimo) return atual
    }
    return atual
  } catch (e) {
    // cor em formato que o MUI não entende (ex.: var(--x)): devolve como veio
    return cor
  }
}

// Texto por cima de um preenchimento colorido (chip ativo, selo): branco só
// quando o branco se lê sobre aquela cor; senão, quase-preto. O ciano e o verde
// da marca são claros demais pra texto branco (1,9:1).
export function textoSobre(fundo) {
  try {
    return getContrastRatio('#ffffff', fundo) >= 4.5 ? '#ffffff' : '#0b1418'
  } catch (e) {
    return '#ffffff'
  }
}

export default corLegivel
